/* eslint-disable indent */
import { memo } from 'react';
import { observer } from 'mobx-react';

import SectionTitle from '../../../../../components/Titles/SectionTitle';
import { SYSTEM_PATH } from '../../../../../core/configs/constants';
import LinkButton from '../../../../../components/Buttons/LinkButton/LinkButton';
import PriceSlideComponent from './PriceSlideComponent/PriceSlideComponent';

import './style.scss';
import { useStore } from '../../../../../core/utils/hook';

const PriceTopPage = observer(({ ticketPlan }) => {
    // store
    const {
        settingTopPageStore: { isPreview }
    } = useStore();

    const isShowTicket = Array.isArray(ticketPlan?.plans) && ticketPlan?.plans?.length > 0;

    return (
        <section id='id-section-price' className="section-price">
            <div className="section-price-curve">
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 1440 134"
                    preserveAspectRatio="none"
                >
                    <path d="M0,10 C480,134 960,134 1440,10 L1440,0 L0,0 Z" fill="" />
                </svg>
            </div>

            <div className="container">
                {ticketPlan?.title ? (
                    <div className="section-price-title">
                        <SectionTitle title={ticketPlan?.title} />
                    </div>
                ) : (
                    <div style={{ width: '100%', height: 50 }}></div>
                )}

                {isShowTicket && (
                    <>
                        <div className="section-price-desc" style={{ whiteSpace: 'pre-wrap' }}>
                            {ticketPlan?.explanation || ''}
                        </div>

                        <div className='ticket-list'>
                            {isShowTicket && (
                                <PriceSlideComponent slides={ticketPlan?.plans} />
                            )}
                        </div>
                    </>
                )}

                <div className='price-content-text'>
                    <div className='text-no-button'>※受講プランを追加購入する場合は、先に購入している プラン分をすべて受講を完了させてください。</div>

                    <div className='content-button content-button-first'>
                        <LinkButton
                            href={isPreview ? undefined : SYSTEM_PATH.REGISTRATION_FIRST_STEP}
                        >
                            新規登録
                        </LinkButton>
                        <div className='text'>お申込みの方はこちらからアカウント登録をお願いします。</div>
                    </div>
                    <div className='content-button'>
                        <LinkButton
                            href={isPreview ? undefined : `${SYSTEM_PATH.SEND_INQUIRY}?category=7`}
                        >
                            法人契約の問い合わせ
                        </LinkButton>
                        <div className='text'>法人のお客様はこちらからお問い合わせ、申し込みをお願いします。</div>
                    </div>
                </div>
            </div>
        </section >
    );
});

export default memo(PriceTopPage);
